import React from 'react';
import { Tooltip } from 'react-tooltip';

import Select from '@components/uikit/Select/Select';

import { getAIStatusesList } from '@helpers/getAIStatusesList';
import { getAITypesList } from '@helpers/getAITypesList';

import useTranslation from '@hooks/useTranslation';

import {
  selectAIStatus,
  selectAIType,
  useActionItemsStorePersistAction,
} from '../../store/useActionItemsStorePersist';
import style from './style.module.scss';

interface IProps {
  id: string;
  visible: boolean;
  setIsOpen: (value: boolean) => void;
}

const ActionItemsHiddenFilter: React.FC<IProps> = ({ id, visible, setIsOpen }) => {
  const { setAIType, setAIStatusType } = useActionItemsStorePersistAction();
  const { t } = useTranslation();

  const typeStore = selectAIType();
  const statusType = selectAIStatus();

  const typesList = getAITypesList(t);
  const statusesList = getAIStatusesList(t);

  return (
    <Tooltip
      id={id}
      place="bottom-start"
      clickable
      className={style.additionalFilters}
      disableStyleInjection
      setIsOpen={(open) => {
        setIsOpen(open);
      }}
      openOnClick
      isOpen={visible}
      render={() => {
        return (
          <div className={style.tooltipContainer}>
            <div className={style.tooltipTitle}>{t('Additional Filters')}</div>
            <div className={style.actionItemsSelectWrapper}>
              <Select
                value={typeStore.value === 'all' ? typesList[0] : typeStore}
                onChange={(option) => setAIType(option)}
                options={typesList}
                label={t('Action Item Type')}
                itemKeys={{ valueFieldKey: 'value', labelFieldKey: 'label' }}
                type={'woHelperText'}
                dataQa={'type-filter'}
              />
            </div>
            <div className={style.actionItemsSelectWrapper}>
              <Select
                value={statusType.value === 'all' ? statusesList[0] : statusType}
                onChange={(option) => setAIStatusType(option)}
                options={statusesList}
                label={t('Status')}
                itemKeys={{ valueFieldKey: 'value', labelFieldKey: 'label' }}
                type={'woHelperText'}
                dataQa={'status-filter'}
              />
            </div>
          </div>
        );
      }}
    />
  );
};

export default ActionItemsHiddenFilter;
